// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"ProjectCategory_Wrapper__oNvPj"};